import { registerPlugin } from '@capacitor/core';

let FacebookAdPluginInstance;

const getFacebookAdPlugin = () => {
  if (!FacebookAdPluginInstance) {
    FacebookAdPluginInstance = registerPlugin('FacebookAdPlugin');
  }
  return FacebookAdPluginInstance;
};

export default getFacebookAdPlugin;